'use client';

import React from 'react';
import pimcoreClient from '../../../apollo/pimcoreClient';
import { SiteContentRegistryProvider } from './SiteContentElementsProvider';

interface SiteContentProvidersProps {
    children: React.ReactNode;
}

export const SiteContentProviders = ({ children }: SiteContentProvidersProps) => {
    return (
        <SiteContentRegistryProvider apolloClient={pimcoreClient} preloadPaths={['/_common']}>
            {children}
        </SiteContentRegistryProvider>
    );
};
